export default __webpack_public_path__ + "04b62b942b35b72b3d705d568f516777.jpg";